import React, { FC, useEffect, useMemo, useState } from 'react';
import { Layout, Row, Col } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import SupplierLocationPageDisplay from '../supplier_location_page_display/SupplierLocationPageDisplay';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWResult from '../OWResult';
import SubnavBar from '../subnav_bar/SubnavBar';
import WorkOrderCreateButton from '../common/WorkOrderCreateButton';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';

const { Content } = Layout;

require('./SupplierLocationsDetailDetailsPage.less');

const SupplierLocationsDetailPage: FC<any> = ({
	getLocation,
	match,
	location,
	locationsFetching,
	locationsError,
}): React.ReactElement => {
	const fetching = locationsFetching && !nullSafeGet('id', location);
	const locationAccessError = nullSafeGetOrElse('length', locationsError, 0) > 0;

	return fetching ? (
		<PageLoadingPlaceholder />
	) : locationAccessError ? (
		<OWResult
			error={'Do not have permission to perform this action'}
			title="You do not have access to this location"
		/>
	) : (
		<Content className="supplierLocationsDetailDetailsPage">
			<Row gutter={12} style={{ marginRight: 4, marginLeft: 4, marginBottom: -8 }}>
				<Col span={24}>
					<SubnavBar
						left={null}
						right={
							<div className="flex flex-row items-center justify-end">
								<WorkOrderCreateButton
									backText="Back to Location Detail"
									getLink={(loc, text, path) =>
										getLinkWIthBackLinkParams(loc, text, `${path}?locationId=${match.params.id}`)
									}
								/>
							</div>
						}
					/>
				</Col>
			</Row>
			<SupplierLocationPageDisplay
				key={nullSafeGet('id', location)}
				record={location}
				locationsFetching={fetching}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	locationsError: state.locations.fetchErrors,
	locationsFetching: state.locations.fetching,
	location: getEntityById(ownProps.match.params.id, state.locations),
	match: ownProps.match,
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(locationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierLocationsDetailPage)
);
